import {
  ContentfulRenderFn,
  CONTENTFUL_BLOCKS,
  ContentfulImage,
} from '@helpful/network';

import { List, ListItem, CheckmarkIcon, Placeholder } from './Index.style';

export const useContentfulDocumentRender = () => {
  const render: ContentfulRenderFn = ({ assets }) => ({
    [CONTENTFUL_BLOCKS.EMBEDDED_ASSET]: (node) => {
      const img = assets.find(
        ({ sys: { id } }) => id === node.data.target.sys.id
      );
      return img ? (
        <Placeholder>
          <ContentfulImage url={img.url} />
        </Placeholder>
      ) : null;
    },
    [CONTENTFUL_BLOCKS.UL_LIST]: (_, children) => {
      return <List>{children}</List>;
    },
    [CONTENTFUL_BLOCKS.LIST_ITEM]: (_, children) => {
      return (
        <ListItem>
          <CheckmarkIcon />
          {children}
        </ListItem>
      );
    },
  });

  return { render };
};
